<template>
    <div>
      <Navbar />
      <Header/>
      <Content/>
      <Footer/>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/Navbar.vue'
  import Header from '@/components/Testimonials/Header.vue';
  import Content from '@/components/Testimonials/Content.vue';
  import Footer from '@/components/Footer.vue';
  export default {
    name: 'Testimonials',
    components: {
      Navbar,
      Header,
      Content,
      Footer
    }
  }
  </script>
  
  <style scoped>
  
  </style>